(ns bleene.layout.theme)

(def dag-palette
  {:brand       "#578956"
   :kleene      "#7ABE79"
   :accent      "#fbc100"
   :darkest     "#828E95"
   :lightest    "#eef1f3"
   :dark        "#7f90a4"
   :light       "#d7d7d7"
   :action      "#009cdf"
   :pending     "#828E95"
   :warning     "#FFB020"
   :success     "#429777"
   :error       "#D14343"
   :background  "#e5e7eb"
   :simple-node "#696f8c"


   ;; Status colors
   "completed" "#8ABB80"
   "succeeded" "#8ABB80"
   "failed"    "#F5564A"
   "pending"   "#FFB020"
   nil         "#828E95"
   :default    "#828E95"})


(def edge-type->color
  {:default  "#CFD5DD"
   :temp     "#3366FF"
   :selected "#55ABDE"
   :in-cycle "#FF0000"
   :connected-to-selected-node "#000"})
